<template>
	<v-container fluid pa-0 style="background-color: #F0F2F8;position: relative;" fill-height class="d-flex flex-column align-start" v-if="!$store.state.user.isAuthenticated">
		<RouterContainer
			v-if="!$store.state.user.loadingCompanyPermissions"
			:style="'height:'+$store.getters['general/availableHeight']+'px'"/>
	</v-container>
	<v-container fluid pa-0 style="background-color: #F0F2F8;position: relative;" fill-height class="d-flex flex-column align-start" v-else-if="loadingUserInfo">
		<FullScreenLoader />
	</v-container>
	<v-container fluid pa-0 style="background-color: #F0F2F8;position: relative;" fill-height class="d-flex flex-column align-start" v-else-if="selectedCompany && $route.name == 'OnlyContent'">
		<RouterContainer
			v-if="!$store.state.user.loadingCompanyPermissions"
			:style="'height:'+$store.getters['general/availableHeight']+'px'"/>
		<Modals v-if="$store.state.user.isAuthenticated"/>
		<ChatRoomCenter />
	</v-container>
	<v-container fluid pa-0 style="background-color: #F0F2F8;position: relative;" fill-height class="d-flex flex-column align-start" v-else-if="selectedCompany">
		<Header v-if="$store.state.user.isAuthenticated"/>
		<Sidebar v-if="$store.state.user.isAuthenticated" />
		<RouterContainer
			v-if="!$store.state.user.loadingCompanyPermissions"
			:style="'height:'+$store.getters['general/availableHeight']+'px'"/>
		<Modals v-if="$store.state.user.isAuthenticated"/>
		<ChatBot />
		<MessageCenter  />
		<ChatRoomCenter />
		<!-- <RTDBNotifications /> -->
		<portal-target name="menu-w-backgrounds"></portal-target>
	</v-container>
	<v-container fluid pa-0 style="background-color: #F0F2F8;position: relative;" fill-height class="d-flex flex-column align-start" v-else>
		<FullScreenNoCompany  v-if="$store.state.user.isAuthenticated"/>
		<RTDBNotifications :noCompany="true" />
	</v-container>
</template>

<script>
import RouterContainer from './RouterContainer'
import Sidebar from './Sidebar'
import Modals from '@/components/Modals'
import MessageCenter from '@/components/Helpers/MessageCenter'
import ChatBot from '@/components/Helpers/ChatBot'
import FullScreenNoCompany from '@/components/Helpers/Components/FullScreenNoCompany'
import FullScreenLoader from '@/components/Helpers/Components/FullScreenLoader'
import RTDBNotifications from '@/components/Helpers/Firebase/RTDBNotifications'
import ChatRoomCenter from '@/components/Helpers/Components/ChatRoomCenter'
import Header from './Header'

export default {
	name: 'MainLayout',
	components: { RouterContainer, Sidebar, Modals, ChatBot, MessageCenter, Header, RTDBNotifications, FullScreenNoCompany, FullScreenLoader, ChatRoomCenter },
	computed: {
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		loadingUserInfo(){
			return this.$store.state.user.loadingUserInfo
		},
		currentRouteName() {
			return this.$route.name;
		}
	},
	data: () => ({}),
};
</script>
